import { TypographyProps } from '@mui/material';

export const marketingBannerSizes = ['lg', 'sm'] as const;

export type MarketingBannerSize = (typeof marketingBannerSizes)[number];

export type MarketingBannerSizeConfig = {
  pt: number;
  pb: number;
  px: number;
  contentGap: number;
  titleGap: number;
  rootGap: number;
  titleVariant: TypographyProps['variant'];
  endContentWidth: number;
  borderRadiusKey: 'lg' | 'md';
};

export const sizeConfigMap: Record<
  MarketingBannerSize,
  MarketingBannerSizeConfig
> = {
  lg: {
    pt: 12,
    pb: 20,
    px: 20,
    contentGap: 16,
    titleGap: 4,
    rootGap: 8,
    titleVariant: 'h4',
    endContentWidth: 98,
    borderRadiusKey: 'lg',
  },
  sm: {
    pt: 8,
    pb: 16,
    px: 16,
    contentGap: 12,
    titleGap: 0,
    rootGap: 4,
    titleVariant: 'A1',
    endContentWidth: 86,
    borderRadiusKey: 'md',
  },
};
